export const GET_ACTION_TOTALS = 'GET_ACTION_TOTALS';
export const GET_POINT_IMPORT = 'GET_POINT_IMPORT';
export const GET_POINT_TOTAL = 'GET_POINT_TOTAL';
export const GET_POINTS_IMPORTS = 'GET_POINTS_IMPORTS';
export const GET_USER_POINTS = 'GET_USER_POINTS';



// WEBPACK FOOTER //
// ./src/constants/points.js